import { Dulap } from '~/components/Landing/Dulap'

export default function HomePage() {
  return <Dulap />
}